import { Region } from 'data/records'
import { resource, collection, findSelector } from 'data/helpers/apiv3'
import { fulfilled } from 'lib/promiseMiddlewareHelpers'
import { Map, OrderedSet } from 'immutable'

const [api, actions] = resource(Region, [
  ['list', collection.get('', ['countryCode', 'zone'])]
])

const selectors = {
  ...findSelector(Region),
  findBySlug: (state, slug) => state.apiv3.region.id.find(r => r.slug === slug),
  allRegions: (state) => state.apiv3.region.get('allRegions', {}),
  namesI18n: (state) => state.apiv3.region.get('namesI18n', {}),
  itemIds: (state, slug, type) => state.apiv3.region.regionItems.getIn([slug, type]) || [],
  nearbyRegionIds: (state, slug) => state.apiv3.region.nearbyRegionIds.get(slug, [])
}

const reducers = {
  [fulfilled(actions.list.type)]: (state, action) => {
    const { allRegions, namesI18n } = action.payload.meta
    return state.set('allRegions', allRegions).set('namesI18n', namesI18n)
  },
  [fulfilled(actions.read.type)]: (state, action) => {
    const { id: slug } = action.meta

    const nextRI = state.regionItems.withMutations(ri => {
      if (!ri.get(slug)) { ri.set(slug, Map()) }

      const ambassadorRouteRouteIds = action.payload.extras.filter(e => e.type === 'ambassador_route').map(ar => ar.ambassador_route.routeId)
      action.payload.extras.forEach(e => {
        const { type, id } = e
        if (type === 'route' && ambassadorRouteRouteIds.includes(id)) {
          // ambassadorRoutes are regionItems, their routes aren't
          return ri
        }
        const last = ri.getIn([slug, type], OrderedSet())

        return ri.setIn([slug, type], last.add(e[type].get('id')))
      })
    })

    return state
      .set('regionItems', nextRI)
      .setIn(['nearbyRegionIds', slug], action.payload.meta.nearbyRegions)
  }
}

const initialState = {
  allRegions: {},
  namesI18n: {},
  regionItems: Map(), // slug -> 'type' -> OrderedSet(records)
  nearbyRegionIds: Map() // slug -> [ids]
}

export {
  api as regionApi,
  actions as regionActions,
  selectors as regionSelectors,
  reducers as regionReducers,
  initialState as regionInitialState
}
